import React, { forwardRef } from 'react';
import { InputDefaultMaskContainer, InputDefaultMaskLabel, InputDefaultMaskField, InputDefaultMaskMessageError } from './styles';
import InputMask from 'react-input-mask';

const InputDefaultMask = forwardRef((props, ref) => {
  return (
    <InputDefaultMaskContainer>
      <InputDefaultMaskLabel htmlFor={props.id}>{props.label}</InputDefaultMaskLabel>
      <InputMask mask={props.mask} value={props.value} maskChar={''} {...props}>
        {(props) => <InputDefaultMaskField ref={props.ref} name={props.name} id={props.id} value={props.value} className={props.error && 'error'} {...props} />}
      </InputMask>
      <input type="hidden" name={props.name} ref={props.register} id={props.id} />
      {props.error && <InputDefaultMaskMessageError error={props.error}>{props.error.message}</InputDefaultMaskMessageError>}
    </InputDefaultMaskContainer>
  )
})

export default InputDefaultMask
